<template>
  <div class="already-container">
    <p>您绑定的passport账号是：{{Phone}}</p>
  </div>
</template>

<script>
export default {
  name: "Already",
  props: {
    passportPhone: String
  },
  computed: {
    Phone() {
      return (
        this.passportPhone.slice(0, 3) +
        "****" +
        this.passportPhone.slice(7, 11)
      );
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.already-container {
  text-align: center;
  padding-top: 100px;
}
p {
  font-size: 20px;
  line-height: 30px;
}
</style>

